import React from 'react';
import '../../styles/mac-os-ui.css';

const MacTable = ({ headers, data, renderRow, title, showViewMore, onViewMoreClick, viewMoreText }) => {
  return (
    <div className="table-container pixel-border">
      {title && <div className="topic">{title}</div>}
      <table>
        <thead>
          <tr className="table-header">
            {headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(data) && data.length > 0 && typeof renderRow === 'function' 
            ? data.map((item, index) => renderRow(item, index))
            : null}
        </tbody>
      </table>
      {showViewMore && (
        <div className="view-more-container text-center">
          <button onClick={onViewMoreClick} className="view-all-btn pixel-border">
            {viewMoreText}
          </button>
        </div>
      )}
    </div>
  );
};

export default React.memo(MacTable);
